// extracted by mini-css-extract-plugin
export default {"inputText":"SearchGS_inputText__9D5Zh"};